exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-d0592266]{max-height:200px}@media (max-width:575px){.btn[data-v-d0592266]{display:block;width:100%}}", ""]);

// exports
